import React from "react";
import howTeams from "../../assets/images/how-teams.png";
import howAi from "../../assets/images/how-ai.png";
import howTimer from "../../assets/images/how-timer.png";
import howBet from "../../assets/images/how-bet.png";
import { Container } from "react-bootstrap";

const steps = [
    [1, "TEAMS ARE MATCHED", howTeams, "AI matches two NBA teams from any era."],
    [2, "AI SIMULATES THE GAME", howAi, "Our AI uses extensive historical stats to simulate every play in real time."],
    [3, "4 QUARTERS. 15 SECONDS EACH.", howTimer, "Fast-paced action. 4 quarters. 15 seconds each. Every possession counts."],
    [4, "PLACE YOUR BET", howBet, "Pick your team, place your bet, and watch history unfold. Win real rewards."],
];

const HowItWorks = () => (
    <Container>
        <section className="shell">
            <div className="section-title"><span>HOW IT WORKS</span></div>
            <div className="steps card">
                {steps.map(([number, title, image, description]) => (
                    <article className="step" key={number}>
                        <div className="step-heading">
                            <b>{number}</b>
                            <strong>{title}</strong>
                        </div>
                        <img src={image} alt="" />
                        <p>{description}</p>
                    </article>
                ))}
            </div>
        </section>
    </Container>
);

export default HowItWorks;
